import { Phone, Mail, MapPin, Truck } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="hazard-stripe-thin h-3 w-full" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="flex h-12 w-12 items-center justify-center border-[3px] border-white bg-[#0A0A0A]">
                <Truck className="h-6 w-6 text-white" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-display text-2xl uppercase">NJI Cleanouts</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-400">
                  We clear the mess.
                </div>
              </div>
            </div>
            <p className="text-neutral-400 leading-relaxed">
              Cleanouts, garbage removal & construction debris hauling. Working alongside NJI Builders.
              Locally operated. Reliable. Professional.
            </p>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.2em] text-[#FFFFFF] mb-4">
              Get In Touch
            </h4>
            <ul className="space-y-3 text-neutral-200">
              <li>
                <a
                  href="tel:+19733069206"
                  data-testid="footer-phone"
                  className="flex items-center gap-3 hover:text-[#0A0A0A]"
                >
                  <Phone className="h-4 w-4" />
                  <span className="font-semibold">(973) 306-9206</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:njicleanout@gmail.com"
                  data-testid="footer-email"
                  className="flex items-center gap-3 hover:text-[#0A0A0A] break-all"
                >
                  <Mail className="h-4 w-4 shrink-0" />
                  <span>njicleanout@gmail.com</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4" />
                <span>Locally operated. Serving most of New Jersey.</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.2em] text-[#FFFFFF] mb-4">
              Services
            </h4>
            <ul className="text-neutral-300 space-y-1.5 text-sm">
              <li>Residential Cleanouts</li>
              <li>Construction Debris Removal</li>
              <li>Dump Runs & Full Truckload Hauling</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-neutral-800 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs uppercase tracking-widest text-neutral-500">
            © {new Date().getFullYear()} NJI Cleanouts · All rights reserved
          </p>
          <p className="text-xs uppercase tracking-widest text-neutral-500">
            NJI Cleanouts — We clear the mess so you don&apos;t have to.
          </p>
        </div>
      </div>
    </footer>
  );
}
